import { render, staticRenderFns } from "./Paginador.vue?vue&type=template&id=7495760a&"
import script from "./Paginador.vue?vue&type=script&lang=js&"
export * from "./Paginador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports